<akeela-change-user-password [config]="config" (response)="getResponse($event)" *ngIf="config"></akeela-change-user-password>